import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FeatureList from './FeatureList';
import PropertyEditor from './PropertyEditor';
import EditTools from './EditTools';
import SampleData from './SampleData';
import { useMapContext } from '../context/MapContext';

const Sidebar = ({ showStatus }) => {
  const { selectedFeature } = useMapContext();
  const [showEditTools, setShowEditTools] = useState(false);
  const { t } = useTranslation();
  
  // Control when to show the edit tools section
  useEffect(() => {
    // Show edit tools whenever there's a selected feature, regardless of editing state
    setShowEditTools(!!selectedFeature);
  }, [selectedFeature]);
  
  return (
    <div className="sidebar">
      <div className="sidebar-section">
        <h2>{t('sidebar.geoJSONFiles')}</h2>
        <SampleData showStatus={showStatus} />
      </div>
      
      <div className="sidebar-section">
        <h2>{t('sidebar.dunList')}</h2>
        <FeatureList />
      </div>
      
      {showEditTools && (
        <div className="sidebar-section">
          <h2>{t('sidebar.editTools')}</h2>
          <EditTools showStatus={showStatus} />
        </div>
      )}
      
      <div className="sidebar-section">
        <h2>{t('sidebar.properties')}</h2>
        {selectedFeature ? (
          <PropertyEditor showStatus={showStatus} />
        ) : (
          <p>{t('propertyEditor.selectFeature')}</p>
        )}
      </div>
      
      <div className="sidebar-section">
        <h2>{t('sidebar.help')}</h2>
        <ul>
          {t('help.instructions', { returnObjects: true }).map((instruction, index) => (
            <li key={index}>{instruction}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
